import React, { createContext, useContext, useState } from 'react';
import { setToken, getToken } from '../services/api';

const AuthContext = createContext();

const USER_STORAGE_KEY = 'investt_auth_user';

function readStoredUser() {
  try {
    const raw = localStorage.getItem(USER_STORAGE_KEY);
    if (!raw || !getToken()) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(readStoredUser);

  // user: { id, name, email, whatsapp, subscriptionStatus, subscriptionDate, renewalDate }
  const login = (token, userData) => {
    setToken(token);
    setUser(userData);
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userData));
  };

  const updateUser = (patch) => {
    setUser((prev) => {
      if (!prev) return prev;
      const record = { ...prev, ...patch };
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(record));
      return record;
    });
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem(USER_STORAGE_KEY);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!user, user, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}